<template>
  <section class="credit-form">
    <TostMessage @close='closeError' v-if="errorState" :message="errorCreditFormMessage"/>
    <svg v-if="loading" class="loader loader-animation" width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="48" cy="48" r="47" stroke="#F1F5F9" stroke-width="2"/>
      <path d="M95 48C95 22.0426 73.9574 1 48 1" stroke="#8C9196" stroke-width="2" stroke-linecap="round"/>
    </svg>

    <ul class="tabs">
      <li class="item m-body-sb" :class="{ active: typeLocal === 'flp' }" v-on:click="typeLocal = 'flp'">Підприємець</li>
      <li class="item m-body-sb" :class="{ active: typeLocal === 'jur' }" v-on:click="typeLocal = 'jur'">Юридична особа</li>
    </ul>

    <div class="form">
      <div class="item">
        <DefaultSelect v-model="typeCreditSelected" label="Вид кредиту" v-bind:options="typeCreditOptions"/>
      </div>

      <div class="item">
        <DefaultSelect v-model="typeTermSelected" label="Строк кредиту місяців" v-bind:options="creditTermOptions" :disabled="creditTermOptions.length <= 1"/>
      </div>

      <div class="item">
        <DefaultInput
          name="sum"
          type="number"
          inputmode="numeric"
          label="Бажана сума кредиту в гривнях"
          v-model="sum"
          :error="errors.has('sum')"
          v-validate="`between:${betweenSum.min},${betweenSum.max}|numeric|required`"
        />
        <span class="error m-footnote-m" v-if="errors.first('sum')">{{ errors.first('sum') }}</span>
      </div>

      <div class="item">
        <DefaultInput
          label="Ім'я"
          v-model="name"
          name="userName"
          :error="errors.has('userName')"
          v-validate="'required'"/>
        <span class="error m-footnote-m" v-if="errors.first('userName')">{{ errors.first('userName') }}</span>
      </div>

      <div class="item">
        <DefaultInput
          name="inn"
          type="number"
          inputmode="numeric"
          :error="errors.has('inn')"
          :label="typeLocal === 'jur' ? 'ЄДРПОУ' : 'ІПН'"
          v-model="inn"
          v-validate="`length:${maxLengthIPN}|required`"
        />
        <span class="error m-footnote-m" v-if="errors.first('inn')">{{ errors.first('inn') }}</span>
      </div>

      <div class="item">
        <DefaultInput
          inputmode="numeric"
          label="Номер телефону"
          name="phoneNumber"
          mask="+380(99)9999999"
          :error="errors.has('phoneNumber')"
          v-model="phoneNumber"
          v-validate="{ required: true, regex: /^([+0-9()]+)$/ }"/>
        <span class="error m-footnote-m" v-if="errors.first('phoneNumber')">{{ errors.first('phoneNumber') }}</span>
      </div>

      <div class="item">
        <DefaultInput
          label="E-mail"
          name="email"
          v-model="email"
          :error="errors.has('email')"
          v-validate="'email|required'"
        />
        <span class="error m-footnote-m" v-if="errors.first('email')">{{ errors.first('email') }}</span>
      </div>
    </div>

    <button class="main-btn second-color large-btn-100" v-on:click="sendData()">Подати заявку</button>

    <PopUp v-if="otp" :width="'100%'" :max-width="'600px'" :height="'auto'" :max-height="'80v'" @close='close'>
      <OTP :otpState="otp" :text="otpText" :otpRef="otpRef"/>
    </PopUp>
  </section>
</template>

<script>
import DefaultInput from '@/components/Ui-new/DefaultInput.vue'
import DefaultSelect from '@/components/Ui-new/DefaultSelect.vue'
import OTP from '@/components/credit-form/OTP.vue'
import PopUp from '@/components/Ui-new/PopUp.vue'
import { HTTP } from '@/httpСommon.js'
import TostMessage from '@/components/Ui-new/TostMessage.vue'

export default {
  components: {
    TostMessage,
    DefaultInput,
    DefaultSelect,
    PopUp,
    OTP
  },
  props: {
    type: {
      type: String,
      default: 'flp'
    },
    defaultCredit: {
      type: String,
      default: 'CREDIT'
    }
  },
  data: function () {
    return {
      typeLocal: '',
      otp: false,
      otpText: '',
      otpRef: '',
      loading: true,
      errorCreditFormMessage: '',
      creditRequestData: [],
      typeCreditSelected: {
        name: '',
        optionId: 'CREDIT'
      },
      typeTermSelected: {},
      sum: '',
      name: '',
      phoneNumber: '',
      inn: '',
      email: '',
      errorState: false
    }
  },
  computed: {
    typeCreditOptions: function () {
      const options = []
      this.creditRequestData.forEach((element) => {
        if (element.id < 4) {
          const option = {
            name: element.name,
            optionId: element.code
          }
          if (element.code === this.defaultCredit) {
            options.unshift(option)
          } else {
            options.push(option)
          }
        }
      })
      return options
    },
    creditTermOptions: function () {
      const options = []
      this.creditRequestData.forEach((element) => {
        if (element.code === this.typeCreditSelected.optionId) {
          for (const type in element.attribute) {
            if (type === this.typeLocal) {
              element.attribute[type].term.forEach((month) => {
                const option = {
                  name: month,
                  optionId: month
                }
                options.push(option)
              })
            }
          }
        }
      })
      return options
    },
    betweenSum: function () {
      let betweenSum = {
        max: 0,
        min: 0
      }
      this.creditRequestData.forEach((element) => {
        if (element.code === this.typeCreditSelected.optionId) {
          for (const type in element.attribute) {
            if (type === this.typeLocal) {
              betweenSum = {
                max: element.attribute[type].sum.max,
                min: element.attribute[type].sum.min
              }
            }
          }
        }
      })
      return betweenSum
    },
    maxLengthIPN: function () {
      if (this.typeLocal === 'flp') {
        return 10
      } else if (this.typeLocal === 'jur') {
        return 8
      } else {
        return 0
      }
    }
  },
  watch: {
    type: {
      immediate: true,
      handler (val) {
        this.typeLocal = val
      }
    }
  },
  methods: {
    close (data) {
      this.otp = data.close
    },
    closeError (data) {
      console.log(data.close)
      this.errorState = data.close
    },
    sendData: function () {
      const dataFlp = {
        lang: 'ua',
        client: {
          type: this.typeLocal,
          inn: this.inn,
          phone: this.phoneNumber,
          name: this.name,
          email: this.email
        },
        product: {
          code: this.typeCreditSelected.optionId,
          sum: Number(this.sum),
          term: this.typeTermSelected.optionId
        }
      }
      const dataJur = {
        lang: 'ua',
        client: {
          type: this.typeLocal,
          edrpo: this.inn,
          phone: this.phoneNumber,
          name: this.name,
          email: this.email
        },
        product: {
          code: this.typeCreditSelected.optionId,
          sum: Number(this.sum),
          term: this.typeTermSelected.optionId
        }
      }
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loading = true
          HTTP
            .post('api/v1/questionnaire/create', JSON.stringify(this.typeLocal === 'flp' ? dataFlp : dataJur),
              {
                headers: {
                  'content-type': 'application/json',
                  Accept: 'application/json'
                }
              }
            )
            .then(response => {
              this.otp = true
              this.otpText = response.data.data.message
              this.otpRef = response.data.data.otp_ref
            })
            .catch(err => {
              this.errorState = true
              this.errorCreditFormMessage = 'Помилка під час завантаження даних'
              this.errorCreditFormMessage = err.response.data.error.message
            })
            .finally(() => (this.loading = false))
        }
      })
    }
  },
  mounted () {
    HTTP
      .get('api/v1/dics/credit-programs')
      .then(response => {
        this.creditRequestData = response.data.data
      })
      .catch(error => {
        console.log(error)
        this.errorState = true
        this.errorCreditFormMessage = 'Помилка під час завантаження даних'
      })
      .finally(() => (this.loading = false))
  }
}
</script>

<style lang="less" scoped>
.credit-form {
  position: relative;
  font-family: 'Montserrat', sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 460px;

  .tabs {
    margin: 0 0 20px 0;
  }

  .loader {
    position: absolute;
    z-index: 99999;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .data-upload-error {
    width: 100%;
    margin: 4px 0 0 0;
  }

  .form {
    margin: 0 0 56px 0;
    width: 100%;

    .item + .item {
      margin: 12px 0 0 0;
    }

    .credit-type {
      color: var(--accent-color);
      font-size: 14px;
    }
  }
}
</style>
